export default __webpack_public_path__ + "static/media/yal.04932e1b.png";